export class FieldMapping{
	name: string;
	type: string;
	format: string;
	index: string;
	hasKeyword: boolean;
	constructor() {
		this.name = '';
		this.type = null;
		this.format = null;
		this.index = null;
		this.hasKeyword = false;
	}
}